// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"355":"c2a9fea2","774":"875f8832"}[chunkId] + ".chunk.js";
};